import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import { DefaultColours } from "../styles/styled";

export const LinkInternal = ({
  style,
  children,
  initialColour,
  bold,
  largeFont,
  to,
  target,
  rel,
  ariaLabel,
  tabIndex,
}: {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  initialColour?: keyof DefaultColours;
  bold?: boolean;
  largeFont?: boolean;
  to: string;
  target?: string;
  rel?: string;
  ariaLabel?: string;
  tabIndex?: number;
}): JSX.Element => {
  const fontWeight = bold ? "bold" : "normal";
  const fontSize = largeFont ? "1.2rem" : "1rem";

  return (
    <LinkStyled
      style={{
        ...style,
        fontWeight,
        fontSize,
      }}
      initialColour={initialColour}
      to={to}
      target={target}
      rel={rel}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    >
      {children}
    </LinkStyled>
  );
};
export const LinkStyled = styled(Link)<{
  initialColour?: keyof DefaultColours;
}>`
  text-decoration: none;
  color: ${(props) => props.theme.colours[props.initialColour || "midBlue"]};
  transition: all 0.2s ease-in;
  &:active {
    outline: none;
  }
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colours.orange};
  }
  // &:visited {
  //   color: ${(props) => props.theme.colours.darkBlue};
  // }
`;
